import {
  useQuery,
  useMutation,
  provideApolloClient,
} from '@vue/apollo-composable';

import apolloClient from '@core/apollo';

/**
 * Services
 */

import { useReactiveMutation } from '@shared/api/mutation';

/**
 * Types
 */
import type {
  CreateContractAttendeeInput,
  CreateContractAttendeeMutation,
  MutationEditContractAttendeeArgs,
  EditContractAttendeeInput,
  DeleteContractAttendeeInput,
  MutationDeleteContractAttendeeArgs,
  DeleteTemplateContractInput,
  DeleteContractTemplateMutation,
  CreateContractDepositInformationInput,
  MutationCreateContractDepositInformationArgs,
  ContractDepositInformationQueryVariables,
  SendReminderInput,
  MutationSendReminderArgs,
} from '@generatedTypes';

/**
 * Mutations
 */
import { CREATE_CONTRACT_DEPOSIT_INFORMATION } from '@core/apollo/mutations/contract';

/**
 * Graphql
 */
import { DeleteContractAttendee } from '@/graphql/mutations/documentAttendee.mutations.gql';
import { SendReminder } from '@/graphql/mutations/signing.mutations.gql';

import {
  CREATE_ATTENDEE_CONTRACT,
  EDIT_CONTRACT_ATTENDEE,
} from '@core/apollo/mutations/documents';

import { DeleteContractTemplateDocument } from '@generatedTypes';
/**
 * Queries
 */

import { CONTRACT_DEPOSIT_INFORMATION } from '@core/apollo/queries/contract';

/**
 * MUTATIONS
 */

export const generateContractAttendee = (
  input?: CreateContractAttendeeInput,
) => {
  return useReactiveMutation<CreateContractAttendeeMutation>(
    CREATE_ATTENDEE_CONTRACT,
    input
      ? {
          variables: {
            input,
          },
        }
      : undefined,
  );
};

export const editContractAttendee = (input?: EditContractAttendeeInput) => {
  return provideApolloClient(apolloClient)(() =>
    useMutation<MutationEditContractAttendeeArgs>(
      EDIT_CONTRACT_ATTENDEE,
      input
        ? {
            variables: {
              input,
            },
          }
        : undefined,
    ),
  );
};

export const deleteContractAttendee = (input?: DeleteContractAttendeeInput) => {
  return provideApolloClient(apolloClient)(() =>
    useMutation<MutationDeleteContractAttendeeArgs>(
      DeleteContractAttendee,
      input
        ? {
            variables: {
              input,
            },
          }
        : undefined,
    ),
  );
};

export const deleteContractTemplate = (input?: DeleteTemplateContractInput) => {
  return useReactiveMutation<DeleteContractTemplateMutation>(
    DeleteContractTemplateDocument,
    input
      ? {
          variables: {
            input,
          },
        }
      : undefined,
  );
};

export const createContractDepositInformation = (
  input?: CreateContractDepositInformationInput,
) => {
  return useReactiveMutation<MutationCreateContractDepositInformationArgs>(
    CREATE_CONTRACT_DEPOSIT_INFORMATION,
    input
      ? {
          variables: {
            input,
          },
        }
      : undefined,
  );
};

export const sendReminder = (input?: SendReminderInput) => {
  return useReactiveMutation<MutationSendReminderArgs>(
    SendReminder,
    input ? { variables: { input } } : undefined,
  );
};

/**
 * QUERIES
 */

export const fetchContractDepositInformation = (
  variables: ContractDepositInformationQueryVariables,
) => {
  return useQuery(CONTRACT_DEPOSIT_INFORMATION, variables, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });
};
